import { ResolvedProgramSummary } from '../../types';
import { ICurrentUser } from '../../../currentuser/currentUser';
import { CalendarViewType, UnscheduledViewType } from '../../containers/types';
import clsx from 'clsx';
import { getProgramPermissionHelper } from '../../programPermissionHelper';
import { hexToRGB, isSocialPostingProgram } from '../../util';
import { ProgramCalendarEventContent } from './ProgramCalendarEventContent';
import React from 'react';

export const ProgramCalendarEvent = (props: {
  program: ResolvedProgramSummary;
  user: ICurrentUser;
  onClick: ((program: ResolvedProgramSummary) => void) | null;
  showCampaigns: boolean;
  applicableVisibleColumns: string[];
  viewType: CalendarViewType | typeof UnscheduledViewType;
  shortcutFieldNamesOnly: boolean;
  hideIcon?: boolean;
}) => {
  const {
    program,
    user,
    onClick,
    showCampaigns,
    applicableVisibleColumns,
    viewType,
    shortcutFieldNamesOnly,
    hideIcon,
  } = props;
  const isSocialPosting = isSocialPostingProgram(program);
  return (
    <div
      data-programid={program.id}
      className={clsx('program-calendar__unscheduled-program', {
        'program-calendar__unscheduled-program--draggable': getProgramPermissionHelper(
          user,
          program
        ).canEditRegularField(),
        'cursor-default': !onClick,
      })}
      style={{
        backgroundColor: isSocialPosting ? 'white' : hexToRGB(program.type.color, 0.1),
        borderColor: hexToRGB(program.type.color, null),
        borderWidth: isSocialPosting ? 1 : 0,
        borderStyle: isSocialPosting ? 'solid' : 'none',
      }}
      onClick={() => onClick && onClick(program)}
    >
      <div
        className="program-calendar__unscheduled-program-container"
        style={{ color: hexToRGB(program.type.color, null) }}
      >
        <ProgramCalendarEventContent
          programSummary={program}
          showCampaigns={showCampaigns}
          visibleColumns={applicableVisibleColumns}
          openCampaignDialog={onClick}
          viewType={viewType}
          isCampaignGrouping={false}
          shortcutFieldNamesOnly={shortcutFieldNamesOnly}
          hideIcon={hideIcon}
        />
      </div>
    </div>
  );
};
